var _path, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgEthx = function SvgEthx(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20 10c0 5.523-4.477 10-10 10S0 15.523 0 10 4.477 0 10 0s10 4.477 10 10Zm-5.715 7.82 3.536-3.535-1.682-1.681a6.69 6.69 0 0 1-3.535 3.535l1.681 1.682Zm-6.424-1.504a6.687 6.687 0 0 1-3.796-3.276l-1.363 1.364 3.536 3.535 1.623-1.623Zm-4-8.92a6.69 6.69 0 0 1 3.535-3.535L6.036 2.5 2.5 6.036l1.36 1.36Zm9.18-3.33 1.446-1.448 3.536 3.536-1.707 1.707a6.687 6.687 0 0 0-3.276-3.796Z",
    fill: "#060710"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#ethx_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m10 5-.066.228v6.612l.067.067 3.069-1.814L10 5Z",
    fill: "#B7B7B7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m10 5-3.068 5.093L10 11.907V5Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m10.003 12.488-.038.046v2.355l.038.11 3.07-4.324-3.07 1.813Z",
    fill: "#939090"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 15v-2.512l-3.068-1.813L10 15Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m10.002 11.907 3.07-1.814-3.07-1.395v3.209Z",
    fill: "#939090"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.932 10.093 10 11.907v-3.21l-3.07 1.396Z",
    fill: "#B1B1B1"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "ethx_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(5 5)",
    d: "M0 0h10v10H0z"
  })))));
};
export default SvgEthx;